import React, { Component } from 'react';
import { Result, Button } from 'antd';
import { logout } from './auth/authActions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Theme from './Theme';
import axios from 'axios';

class UnAuthorizedUserError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workspaces: [],
      loading: true,
    };
  }

  componentDidMount() {
    axios.get('/api/workspaces').then((res) => {
      if (
        res.data &&
        res.data.success &&
        res.data.workspaces &&
        res.data.workspaces.length > 0
      )
        this.setState({ workspaces: res.data.workspaces, loading: false });
    });
  }

  render() {
    const { loading, workspaces } = this.state;
    const workspace_id =
      workspaces && workspaces[0] && workspaces[0]._id
        ? workspaces[0]._id
        : null;
    return (
      <div style={{ overflow: 'auto', height: '100vh', width: '100vw' }}>
        <Theme />
        <Result
          status='404'
          title='Page Not Found'
          subTitle='Contact your Troopr administrator if you think this is a mistake'
          extra={
            <Button
              type='primary'
              onClick={() => {
                if (workspaces && workspaces[0] && workspaces[0]._id)
                  window.location.href = `/${workspaces[0]._id}/dashboard`;
              }}
              loading={loading}
              disabled={loading || !workspace_id}
            >
              Back Home
            </Button>
          }
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              type='link'
              onClick={() => {
                this.props.logout();
                window.location.href = '/troopr/access';
              }}
            >
              Sign out and sign in with a different account
            </Button>
            <Button type='link' href='http://docs.troopr.ai' target='_blank'>
              Troopr Help Center
            </Button>
          </div>
        </Result>
      </div>
    );
  }
}

export default connect(null, {
  logout,
})(UnAuthorizedUserError);
